import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-20c8f05e")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"center"} }, "抽取小组", -1)
const _hoisted_2 = { class: "group-info" }
const _hoisted_3 = ["src"]
_popScopeId()

import BaseModal from "../base/BaseModal.vue";
import {
  computed,
  onMounted,
  ref,
  watch,
  inject,
} from "vue";
import _ from "lodash";


export default _defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: () => false,
  },
  groupList: {
    type: Array,
    default: () => [],
  },
},
  emits: ["update:visible", "openModal"] as unknown as undefined,
  setup(__props, { emit }: { emit: ({
  (event: "update:visible", data: any): void;
  (event: "openModal", data: any, boolean: any): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props




const groupList = computed(() => props.groupList);

const currentGroup = ref();

const handleSelectRandomGroup = () => {
  const index = _.random(0, groupList.value.length - 1);
  currentGroup.value = groupList.value[index];
};

const handleShowAppraiseModal = inject("handleShowAppraiseModal");

const handleSelectGroup = () => {
  handleClose();
  emit("openModal", currentGroup.value, true);
};

const handleClose = () => {
  emit("update:visible", false);
};

// 将节点挂载到body
const CIBodyRef: any = inject("CIBodyRef");
const setBodyRef = () => CIBodyRef.value;

watch(
  () => props.visible,
  (v) => {
    if (v) {
      handleSelectRandomGroup();
    }
  },
  { immediate: true }
);

onMounted(() => {
  handleSelectRandomGroup();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    "body-style": {
      width: '43.9rem',
      height: '30.9rem',
    },
    visible: __props.visible,
    onOnClose: handleClose,
    getContainer: setBodyRef
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: 
          require(`@/assets/img/classroomInteraction/groupAvatar/${currentGroup.value.avatarId}.png`)
        
        }, null, 8, _hoisted_3),
        _createElementVNode("text", null, _toDisplayString(currentGroup.value.name) + " " + _toDisplayString(currentGroup.value.students.length) + "人 ", 1)
      ]),
      _createElementVNode("div", { class: "operation" }, [
        _createElementVNode("div", {
          class: "base-btn cancel",
          onClick: handleSelectRandomGroup
        }, " 重新抽选 "),
        _createElementVNode("div", {
          class: "base-btn confirm",
          onClick: handleSelectGroup,
          style: {"margin-left":"30px"}
        }, " 发送点评 ")
      ])
    ]),
    _: 1
  }, 8, ["body-style", "visible"]))
}
}

})